/**
 * GENERATED by tools/slice-sprites.mjs - do not edit by hand.
 *
 * Vite resolves these imports to hashed asset URLs at build time, so the
 * sprites are content-hashed and cacheable rather than fetched by name.
 */

import { BUILDINGS, type BuildingType } from '@waldermarch/shared';

import a_barracks_1_webp from './barracks-1.webp';
import a_barracks_2_webp from './barracks-2.webp';
import a_barracks_3_webp from './barracks-3.webp';
import a_church_1_webp from './church-1.webp';
import a_church_2_webp from './church-2.webp';
import a_church_3_webp from './church-3.webp';
import a_clay_pit_1_webp from './clay_pit-1.webp';
import a_clay_pit_2_webp from './clay_pit-2.webp';
import a_clay_pit_3_webp from './clay_pit-3.webp';
import a_dockyard_1_webp from './dockyard-1.webp';
import a_dockyard_2_webp from './dockyard-2.webp';
import a_dockyard_3_webp from './dockyard-3.webp';
import a_farm_1_webp from './farm-1.webp';
import a_farm_2_webp from './farm-2.webp';
import a_farm_3_webp from './farm-3.webp';
import a_gatehouse_1_png from './gatehouse-1.png';
import a_icon_cavalry_png from './icon-cavalry.png';
import a_icon_clay_png from './icon-clay.png';
import a_icon_clay_pit_png from './icon-clay_pit.png';
import a_icon_gold_png from './icon-gold.png';
import a_icon_grain_png from './icon-grain.png';
import a_icon_iron_png from './icon-iron.png';
import a_icon_military_png from './icon-military.png';
import a_icon_settings_png from './icon-settings.png';
import a_icon_smithy_png from './icon-smithy.png';
import a_icon_storage_png from './icon-storage.png';
import a_icon_timber_camp_png from './icon-timber_camp.png';
import a_icon_village_png from './icon-village.png';
import a_icon_wall_png from './icon-wall.png';
import a_icon_wood_png from './icon-wood.png';
import a_iron_mine_1_webp from './iron_mine-1.webp';
import a_iron_mine_2_webp from './iron_mine-2.webp';
import a_iron_mine_3_webp from './iron_mine-3.webp';
import a_manor_house_1_webp from './manor_house-1.webp';
import a_manor_house_2_webp from './manor_house-2.webp';
import a_manor_house_3_webp from './manor_house-3.webp';
import a_manor_house_4_webp from './manor_house-4.webp';
import a_market_1_webp from './market-1.webp';
import a_market_2_webp from './market-2.webp';
import a_market_3_webp from './market-3.webp';
import a_smithy_1_webp from './smithy-1.webp';
import a_smithy_2_webp from './smithy-2.webp';
import a_smithy_3_webp from './smithy-3.webp';
import a_stable_1_webp from './stable-1.webp';
import a_stable_2_webp from './stable-2.webp';
import a_stable_3_webp from './stable-3.webp';
import a_timber_camp_1_webp from './timber_camp-1.webp';
import a_timber_camp_2_webp from './timber_camp-2.webp';
import a_timber_camp_3_webp from './timber_camp-3.webp';
import a_wall_1_webp from './wall-1.webp';
import a_wall_2_webp from './wall-2.webp';
import a_wall_3_webp from './wall-3.webp';
import a_warehouse_1_webp from './warehouse-1.webp';
import a_warehouse_2_webp from './warehouse-2.webp';
import a_warehouse_3_webp from './warehouse-3.webp';
import a_workshop_1_png from './workshop-1.png';
import a_workshop_2_png from './workshop-2.png';
import a_workshop_3_png from './workshop-3.png';

export interface SpriteTier {
  tier: number;
  url: string;
  width: number;
  height: number;
}

/** Building artwork, lowest tier first. */
export const BUILDING_SPRITES: Record<string, SpriteTier[]> = {
  manor_house: [
    { tier: 1, url: a_manor_house_1_webp, width: 231, height: 243 },
    { tier: 2, url: a_manor_house_2_webp, width: 288, height: 255 },
    { tier: 3, url: a_manor_house_3_webp, width: 322, height: 274 },
    { tier: 4, url: a_manor_house_4_webp, width: 400, height: 362 },
  ],
  warehouse: [
    { tier: 1, url: a_warehouse_1_webp, width: 278, height: 224 },
    { tier: 2, url: a_warehouse_2_webp, width: 333, height: 293 },
    { tier: 3, url: a_warehouse_3_webp, width: 400, height: 374 },
  ],
  farm: [
    { tier: 1, url: a_farm_1_webp, width: 300, height: 184 },
    { tier: 2, url: a_farm_2_webp, width: 373, height: 248 },
    { tier: 3, url: a_farm_3_webp, width: 400, height: 278 },
  ],
  market: [
    { tier: 1, url: a_market_1_webp, width: 246, height: 173 },
    { tier: 2, url: a_market_2_webp, width: 378, height: 233 },
    { tier: 3, url: a_market_3_webp, width: 400, height: 342 },
  ],
  timber_camp: [
    { tier: 1, url: a_timber_camp_1_webp, width: 350, height: 272 },
    { tier: 2, url: a_timber_camp_2_webp, width: 400, height: 356 },
    { tier: 3, url: a_timber_camp_3_webp, width: 360, height: 391 },
  ],
  clay_pit: [
    { tier: 1, url: a_clay_pit_1_webp, width: 298, height: 204 },
    { tier: 2, url: a_clay_pit_2_webp, width: 400, height: 270 },
    { tier: 3, url: a_clay_pit_3_webp, width: 380, height: 347 },
  ],
  iron_mine: [
    { tier: 1, url: a_iron_mine_1_webp, width: 314, height: 204 },
    { tier: 2, url: a_iron_mine_2_webp, width: 400, height: 283 },
    { tier: 3, url: a_iron_mine_3_webp, width: 322, height: 330 },
  ],
  barracks: [
    { tier: 1, url: a_barracks_1_webp, width: 272, height: 199 },
    { tier: 2, url: a_barracks_2_webp, width: 331, height: 237 },
    { tier: 3, url: a_barracks_3_webp, width: 400, height: 259 },
  ],
  stable: [
    { tier: 1, url: a_stable_1_webp, width: 244, height: 210 },
    { tier: 2, url: a_stable_2_webp, width: 315, height: 268 },
    { tier: 3, url: a_stable_3_webp, width: 400, height: 376 },
  ],
  smithy: [
    { tier: 1, url: a_smithy_1_webp, width: 318, height: 212 },
    { tier: 2, url: a_smithy_2_webp, width: 380, height: 192 },
    { tier: 3, url: a_smithy_3_webp, width: 400, height: 213 },
  ],
  workshop: [
    { tier: 1, url: a_workshop_1_png, width: 64, height: 59 },
    { tier: 2, url: a_workshop_2_png, width: 78, height: 71 },
    { tier: 3, url: a_workshop_3_png, width: 111, height: 95 },
  ],
  wall: [
    { tier: 1, url: a_wall_1_webp, width: 320, height: 559 },
    { tier: 2, url: a_wall_2_webp, width: 384, height: 679 },
    { tier: 3, url: a_wall_3_webp, width: 354, height: 648 },
  ],
  gatehouse: [
    { tier: 1, url: a_gatehouse_1_png, width: 138, height: 143 },
  ],
  dockyard: [
    { tier: 1, url: a_dockyard_1_webp, width: 269, height: 214 },
    { tier: 2, url: a_dockyard_2_webp, width: 387, height: 310 },
    { tier: 3, url: a_dockyard_3_webp, width: 400, height: 402 },
  ],
  church: [
    { tier: 1, url: a_church_1_webp, width: 303, height: 269 },
    { tier: 2, url: a_church_2_webp, width: 350, height: 345 },
    { tier: 3, url: a_church_3_webp, width: 400, height: 365 },
  ],
};

export const UI_ICONS: Record<string, string> = {
  village: a_icon_village_png,
  storage: a_icon_storage_png,
  grain: a_icon_grain_png,
  gold: a_icon_gold_png,
  wood: a_icon_wood_png,
  timber_camp: a_icon_timber_camp_png,
  clay_pit: a_icon_clay_pit_png,
  clay: a_icon_clay_png,
  iron: a_icon_iron_png,
  military: a_icon_military_png,
  cavalry: a_icon_cavalry_png,
  smithy: a_icon_smithy_png,
  settings: a_icon_settings_png,
  wall: a_icon_wall_png,
};

/**
 * Which artwork tier a building level shows.
 *
 * The bands are derived rather than fixed, because buildings differ in both
 * how many tiers were drawn for them and how far they can be raised: the
 * Manor has four tiers across thirty levels, the Smithy three across twenty.
 * Each tier therefore owns an equal share of its own ladder, so the last
 * tier always appears at the same fraction of the way up whatever the
 * building's ceiling happens to be.
 *
 * Without a type it answers for the common case, three tiers over thirty.
 */
export function spriteTierForLevel(level: number, type?: string): number {
  const tiers = type ? (BUILDING_SPRITES[type]?.length ?? 3) : 3;
  const max = (type && BUILDINGS[type as BuildingType]?.maxLevel) || 30;
  for (let tier = tiers; tier >= 1; tier--) {
    if (level >= Math.round((max * (tier - 1)) / tiers)) return tier;
  }
  return 1;
}

/** Best available artwork for a building at a level. Null if unillustrated. */
export function buildingSprite(type: string, level: number): SpriteTier | null {
  const tiers = BUILDING_SPRITES[type];
  if (!tiers || tiers.length === 0) return null;
  const wanted = spriteTierForLevel(level, type);
  // Fall back to the highest tier that was actually drawn.
  let best = tiers[0];
  for (const t of tiers) if (t.tier <= wanted) best = t;
  return best;
}
